import { token } from '@atlaskit/tokens';
import { skeletonShimmer } from '@atlaskit/theme/constants';
import { N20A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, keyframes, type CSSObject } from '@emotion/react';
import { grid } from '../style-utils';

const smallItemElemSpacing = grid.multiple(1.5).unitless;
const itemElemSpacing = grid.multiple(1).unitless;
const itemElemSize = grid.multiple(3).unitless;
const itemMinHeight = grid.multiple(5).unitless;

const skeletonContentHeight = grid.multiple(1.75).unitless / 2;

const shimmer = skeletonShimmer();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const shimmerKeyframes = keyframes(shimmer.keyframes);

type SmallAvatarShape = 'small-circle' | 'small-square';
export type AvatarShape = 'circle' | 'square' | SmallAvatarShape;

const isSmallAvatar = (avatarShape: AvatarShape) => {
	return avatarShape.indexOf('small') === 0;
};

const isCircleAvatar = (avatarShape: AvatarShape) => {
	return avatarShape.indexOf('circle') !== -1;
};

export const avatarSkeletonCSS = (avatarShape: AvatarShape, isShimmering?: boolean): CSSObject => ({
	// This will render a skeleton in the "elemBefore" position.
	backgroundColor: token('color.skeleton', N20A),
	...(isShimmering && {
		...shimmer.css,
		animationName: `${shimmerKeyframes}`,
	}),
	marginRight: isSmallAvatar(avatarShape) ? smallItemElemSpacing : itemElemSpacing,
	width: isSmallAvatar(avatarShape) ? '14px' : itemElemSize,
	height: isSmallAvatar(avatarShape) ? '14px' : itemElemSize,
	borderRadius: isCircleAvatar(avatarShape) ? token('radius.full') : token('radius.small', '3px'),
	flexShrink: 0,
	display: 'inline-block',
});

const itemCSS = css({
	cursor: 'pointer',
	font: token('font.body'),
	display: 'block',
	width: '100%',
	boxSizing: 'border-box',
	backgroundColor: 'transparent',
	border: 0,
	outline: 0,
	margin: 0,
});

export const labelSkeletonCSS = (
	width?: string | number,
	isShimmering?: boolean,
	textHeight?: number,
) => ({
	// This will render the skeleton "text".
	backgroundColor: token('color.skeleton', N20A),
	...(isShimmering && {
		...shimmer.css,
		animationName: `${shimmerKeyframes}`,
	}),
	height: `${textHeight ? textHeight / 2 : skeletonContentHeight}px`,
	borderRadius: token('radius.small', '3px'),
	flexBasis: width || '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const itemSkeletonCSS = css([
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	itemCSS,
	{
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		minHeight: itemMinHeight,
	},
]);
